import { render, staticRenderFns } from "./RedirectUrl.vue?vue&type=template&id=36e72581&"
import script from "./RedirectUrl.vue?vue&type=script&lang=js&"
export * from "./RedirectUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports